import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'vpa-action-item',
  templateUrl: './action-item.component.html',
  styleUrls: ['./action-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActionItemComponent implements OnInit {
  @Input() buttonText: string;
  @Input() iconClass: string;
  @Input() customContainerClass: string;

  @Output() buttonClicked: EventEmitter<void> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  onButtonClicked(): void {
    this.buttonClicked.emit();
  }
}
